import { forwardRef } from 'react';
import { cx } from 'class-variance-authority';
import { Box } from '../Box';
import { BaseTypeMap, Component, ComponentProps } from '../types/Component';

import * as styles from './styles';

type StepsRootTypeMap = BaseTypeMap<'nav', styles.RootStyleProps>;

export type StepsRootProps = ComponentProps<StepsRootTypeMap>;

export const StepsRoot: Component<StepsRootTypeMap> = forwardRef(
  function StepsRoot({ children, className, color, direction, ...rest }, ref) {
    return (
      <Box as="nav" className={cx(className)} ref={ref} {...rest}>
        <Box as="ol" className={styles.root({ direction })}>
          {children}
        </Box>
      </Box>
    );
  }
);
